<template>
  <div
    class="flex flex-col items-center justify-center bg-avtalat-teal px-lg py-md text-white"
    v-if="headerState"
  >
    <MinaForetag v-if="showMinaForetag" />
    <div
      v-if="
        showMinaForetag &&
        arbetsgivareStore.arbetsgivare.foretag &&
        individStore.individ.data &&
        individStore.minaForetag.data
      "
      :className="
        isArbetsgivarerepresentant
          ? 'arbetsgivare-header__arbetsgivarrepresentant'
          : 'arbetsgivare-header__not-arbetsgivarrepresentant'
      "
    >
      {{
        individStore.individ.data?.fornamn +
        " " +
        individStore.individ.data?.efternamn
      }}
      <span
        :className="
          isArbetsgivarerepresentant
            ? 'arbetsgivare-header__arbetsgivarrepresentant-personnummer'
            : 'arbetsgivare-header__not-arbetsgivarrepresentant'
        "
        >{{ individStore.individ.data?.personnummer + " " }}</span
      ><span v-if="isArbetsgivarerepresentant"
        >är arbetsgivarrepresentant för:</span
      ><span
        v-if="!isArbetsgivarerepresentant"
        className="arbetsgivare-header__not-arbetsgivarrepresentant"
        >är inte arbetsgivarrepresentant för:</span
      >
    </div>
    <div className="type-heading-md arbetsgivare-header__foretag">
      <div class="arbetsgivare-header__heading-name">
        {{ headerState.foretagNamn }}
      </div>
      <div class="arbetsgivare-header__heading-orgnumber">
        {{ headerState.organisationsnummer }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useConfigStore, useIndividStore } from "@/stores";

import MinaForetag from "./MinaForetag.vue";
import { useArbetsgivareStore } from "./store";

const configStore = useConfigStore();
const showMinaForetag = computed(() =>
  configStore.getFeatureFlag("arbetsgivare.minaForetag"),
);
const arbetsgivareStore = useArbetsgivareStore();
const individStore = useIndividStore();
const headerState = computed(() => arbetsgivareStore.headerSection);
const isArbetsgivarerepresentant = computed(() =>
  individStore.isArbetsgivarerepresentant(
    headerState?.value?.organisationsnummer,
  ),
);
</script>

<style>
.arbetsgivare-header__arbetsgivarrepresentant {
  margin-bottom: 1em;
}

.arbetsgivare-header__not-arbetsgivarrepresentant {
  margin-bottom: 1em;
  color: red;
}

.arbetsgivare-header__arbetsgivarrepresentant-personnummer {
  color: var(--neutral-700);
}

.arbetsgivare-header__foretag {
  display: flex;
  align-items: center;
}

.arbetsgivare-header__heading-name {
  margin: 0 0.5em;
}
</style>
